(function(){
  if (window.__recentlyViewedInit) return;
  window.__recentlyViewedInit = true;

  var KEY = 'hp_recently_viewed';
  var MAX = 8;

  function storageAvailable(){
    try{
      var test = '__rv__';
      localStorage.setItem(test, test);
      localStorage.removeItem(test);
      return true;
    }catch(e){
      return false;
    }
  }

  var hasStorage = storageAvailable();

  function getList(){
    if(!hasStorage) return [];
    try{
      return JSON.parse(localStorage.getItem(KEY) || '[]');
    }catch(e){
      return [];
    }
  }

  function saveList(list){
    if(!hasStorage) return;
    localStorage.setItem(KEY, JSON.stringify(list));
  }

  function addHandle(handle){
    if(!handle || !hasStorage) return;
    var list = getList().filter(function(h){ return h !== handle; });
    list.unshift(handle);
    list = list.slice(0, MAX);
    saveList(list);
  }

  function renderSection(section){
    if(!section || !hasStorage) return;
    var grid = section.querySelector('[data-rv-grid]');
    var empty = section.querySelector('[data-rv-empty]');
    if(!grid) return;
    var current = section.getAttribute('data-current-handle') || '';
    var list = getList().filter(function(h){ return h !== current; }).slice(0, MAX);

    if(!list.length){
      section.style.display = 'none';
      return;
    }

    section.style.display = 'none';
    if(empty) empty.style.display = 'none';
    grid.innerHTML = '';

    Promise.all(list.map(function(handle){
      return fetch('/products/' + handle + '?section_id=recently-viewed-card')
        .then(function(r){ return r.text(); })
        .then(function(html){
          var wrap = document.createElement('div');
          wrap.innerHTML = html;
          return wrap.querySelector('[data-rv-card]');
        })
        .catch(function(){ return null; });
    })).then(function(cards){
      var valid = cards.filter(Boolean);
      if(!valid.length){
        section.style.display = 'none';
        return;
      }
      valid.forEach(function(card){ grid.appendChild(card); });
      section.style.display = '';
    });
  }

  function init(){
    var sections = document.querySelectorAll('[data-recently-viewed-section]');
    if(!hasStorage){
      sections.forEach(function(s){ s.style.display='none'; });
      return;
    }
    sections.forEach(renderSection);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:select', init);

  var handleEl = document.querySelector('[data-recently-viewed-handle]');
  if(handleEl){
    addHandle(handleEl.getAttribute('data-recently-viewed-handle'));
  }
})();
